$(function() {
    // console.log('page');
});